$(function() {
    // console.log('page');
});